import { Component, inject, Input, OnInit } from '@angular/core';
import { InputAppDataService } from '@monorepo/services';
import { ModalController, IonicModule } from '@ionic/angular';
import { TSelectedProductionReason } from '@monorepo/types';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'monorepo-production-reason-list',
  templateUrl: './production-reason-list.component.html',
  styleUrls: ['./production-reason-list.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
})
export class ProductionReasonListComponent implements OnInit {
  inputAppDataService = inject(InputAppDataService);
  @Input() productionReasonList: TSelectedProductionReason[] = [];
  private modalController = inject(ModalController);

  ngOnInit(): void {}

  closeModal() {
    this.modalController.dismiss();
  }

  selectReason(reason: TSelectedProductionReason) {
    this.productionReasonList = this.productionReasonList.map((item) => {
      if (item.reason.reasonId === reason.reason.reasonId) {
        return { ...item, selected: !item.selected };
      }
      return item;
    });
  }

  save() {
    this.modalController.dismiss(
      this.productionReasonList.filter((item) => item.selected).map((item) => item.reason.reasonName),
    );
  }
}
